import React,{useState,useEffect} from "react";
import { useTranslation } from "react-i18next";

const HomePage =()=> {
  const {t} = useTranslation();
  return (
    <div className="home">
        {" "}
    </div>
  );
}

export default HomePage;
